import { Pulse, PulseGlobalInternals } from '@pulse/common';

export function fireOnReady(g: PulseGlobalInternals, instance: Pulse) {
    g.ready?.forEach((callback: (instance: Pulse) => void) => callback(instance));
    g.ready?.splice(0, g.ready.length);
    g.ready.push = function (callback: (instance: Pulse) => void) {
        callback(instance);

        return 0;
    };
}
